export enum NotificationsTransactionType {
  Spent = "spent",
  SalaryAdded = "salary_added",
  Increment = "Increment",
  Decrement = "Decrement",
}
